import { render } from "./TransformToolbar.vue?vue&type=template&id=45386839&scoped=true"
import script from "./TransformToolbar.vue?vue&type=script&lang=js"
export * from "./TransformToolbar.vue?vue&type=script&lang=js"

import "./TransformToolbar.vue?vue&type=style&index=0&id=45386839&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45386839"]])

export default __exports__